(function (app, ng) {
    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.ManageStockQuestions",
                {
                    url: "/ManageStockQuestions",
                    component: "manageStockQuestions",
                    resolve: {
                        stockQuestions: ["stockQuestionApi", function (stockQuestionApi) {
                            return stockQuestionApi.getAllStockQuestions();
                        }]
                    }
                });
        }
    ]);

    app.component("manageStockQuestions",
        {
            templateUrl: "App/Dashboard/ManageStockQuestions/template.html",
            controller: manageStockQuestionsController,
            bindings: {
                stockQuestions: "<"
            }
        });

    manageStockQuestionsController.$inject = ["$state", "$mdDialog"];

    function manageStockQuestionsController($state, $mdDialog) {
        this.$state = $state;

        var $ctrl = this;

        ng.extend($ctrl,
            {
                UI: {
                    isClosing: false,
                    isSaving: false
                },
                newStockQuestion: newStockQuestion,
                editStockQuestion: editStockQuestion,
                close: close
            });

        this.$onInit = function () {
            $ctrl.manageAllEntities = "Manage Stock Questions";
            $ctrl.backToConfig = "Back to Home";
            $ctrl.questionTxt = "Question";
            $ctrl.typeLabel = "Type";
            $ctrl.plugins = "Plugin(S)";
            $ctrl.lastUpdated = "Last Updated";
            $ctrl.typeLookup = [];
            $ctrl.typeLookup["SelectOne"] = "Select One";
            $ctrl.typeLookup["SelectMany"] = "Select Many";
            $ctrl.typeLookup["LongText"] = "Long Text";
            $ctrl.typeLookup["ShortText"] = "Short Text";
        }

        function newStockQuestion() {
            return $state.go("Home.ManageStockQuestions.NewStockQuestion");
        }

        function editStockQuestion(q) {
            return $state.go("Home.ManageStockQuestions.ConfigureStockQuestion", { stockQuestionId: q.stockQuestionId });
        }
    }

})(window.app, window.angular);
